import { makeStyles } from "@fluentui/react-components";

export const useSuggestionFilterFormStyles = makeStyles({
  formContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
    alignItems: "flex-start",
    rowGap: "24px",
    overflow: "hidden",
    padding: "16px 0",
    boxSizing: "border-box",
  },
  toolbarContainer: {
    textAlign: "center",
    boxSizing: "border-box",
    width: "100%",
    padding: "0 20px",
  },
  formRow: {
    width: "100%",
    flex: "0 0.8 auto",
    overflowY: "auto",
    overflowX: "hidden",
  },
  filterForm: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    rowGap: "16px",
    boxSizing: "border-box",
    padding: "0 20px",
    overflowY: "auto",
    overflowX: "hidden",
  },
  textInputArea: {
    minHeight: "90px",
    minWidth: "100%",
  },
  formActionContainer: {
    display: "flex",
    flexDirection: "row",
    columnGap: "17px",
    width: "100%",
    padding: "0 20px",
    boxSizing: "border-box",
    "@media screen and (max-width: 500px)": {
      flexDirection: "column",
      gap: "8px",
    },
  },
  formActionBtn: {
    minWidth: "165px",
    fontWeight: "bold",
  },
  fullWidth: {
    minWidth: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  dividerContainer: {
    height: "20px",
  },
  dividerText: {
    color: "#242424",
    fontSize: "12px",
    lineHeight: "16px",
    wordWrap: "break-word",
  },
  filterInputsContainer: {
    display: "flex",
    flexDirection: "column",
    rowGap: "12px",
    flexGrow: 1,
    alignItems: "flex-start",
    boxSizing: "border-box",
  },
  filterContainerSurface: {
    padding: "0px",
    height: "60vh",
    width: "430px",
    overflow: "hidden",
    "@media screen and (max-height: 800px)": {
      height: "70vh",
    },
    "@media screen and (max-width: 500px)": { width: "80vw" },
  },
});
